import axios, { AxiosInstance } from 'axios';

import { ENVIRONMENT } from '../environment';

export type GetAuthTokenFn = () => Promise<string | undefined>;

export interface AbstractApiParams {
  baseUrl: string;
  getAuthToken: GetAuthTokenFn;
}

export class AbstractApi {
  constructor(protected params: AbstractApiParams) {}

  protected async axios(): Promise<AxiosInstance> {
    const token = await this.params.getAuthToken();
    return axios.create({
      baseURL: this.params.baseUrl,
      headers: {
        tenant: ENVIRONMENT.publicGateway.tenant,
        'application-id': ENVIRONMENT.publicGateway.applicationId,
        authorization: token,
      },
    });
  }
}
